export const faqData: any = {
  MyAccount: [
    {
      title: 'What should a store manager do on receipt of JioPay DQR standee?',
      subTitles: [
        `After receipt of device, the store manager is supposed to do the following activity - 
  •  He needs to do GRN entry.
  •  Watch DIY Video on device installation.
  •  He should match the devices to billing system – One device per billing system. If mismatch then he should report the same to the RRL support team and his cluster managers.
  •  Connect device to USB port of the billing system, as shown in the video.
  •  Do the “Sign out” and “Sign” in the billing system/RPoS application.
  •  Same step to be followed for each of the billing systems/RPoS application in his store.`,
      ],
    },
    {
      title: 'Who will send the store manager the JioPay DQR?',
      subTitles: ['The devices would be dispatched by the local State Digital DC.'],
    },
    {
      title: 'What if the neighborhood smart point have it and a particular store manager doesn’t have it.',
      subTitles: [
        {
          text: 'The store manager should reach out via the RRL team based out of RCP by writing to <a>merchant.support@jiopay.in</a>.',
          link: 'merchant.support@jiopay.in',
        },
      ],
    },
    {
      title: 'What if the DQR device is defective?',
      subTitles: [
        {
          text: 'The store manager should reach out to the RRL support team or write an email to merchant support [<a>merchant.support@jiopay.in</a>] – Please specify the details the store manager needs to include while sending such emails.',
          link: 'mailto:merchant.support@jiopay.in',
        },
      ],
    },
    {
      title: 'What if the store manager has received excess or lesser number of devices?',
      subTitles: [
        'The store manager would have to share this information with RRL Support team. Accordingly, return or delivery of additional devices would be planned. Please mention the email ids along with the details store manager has to add while sending such emails.',
      ],
    },
    {
      title: 'How do I start using the DQR device for transactions?',
      subTitles: [
        {
          text: `•	It is a plug and play device. The store manager would have to connect the USB port of the device to the USB port of the RPoS Billing system.
  •	Further, the screen will appear and the store manager would have to do “signout” and “sign in”.
  •	After that, the store manager can do a Re1 test transaction and select “JioPay UPI DQR” option at the time of checkout as MOP. The DQR code would then generate instantaneously on the DQR Device. He may then scan and pay using any of the UPI/BHIM applications.
  •	In case of any issues, the store manager may connect with RRL Support team or write a mail to <a>merchant.support@jiopay.in</a>.`,
          link: 'mailto:merchant.support@jiopay.in',
        },
      ],
    },
    {
      title: 'What all UPI payment applications/options would JioPay DQR support?',
      subTitles: [
        'Customer can make payment via any of the UPI applications such as MyJio, PhonePe, GPay, Paytm, etc.',
      ],
    },
    {
      title: 'Internet connectivity issue or network issues because of which UPI is not working',
      subTitles: [
        {
          text: 'Store manager needs to raise with RRL Enterprise IT team: <a>Retailit@ril.com</a>.',
          link: 'mailto:Retailit@ril.com',
        },
      ],
    },
    {
      title: 'What if the DQR is not working after connecting to RPoS Billing System?',
      subTitles: [
        {
          text: 'The store manager may reach out to merchant support team <a>merchant.support@jiopay.in</a>. Please mention the details store manager has to provide while raising such concerns.',
          link: 'mailto:merchant.support@jiopay.in',
        },
      ],
    },
    {
      title: 'How to initiate refund in normal DQR transactions',
      subTitles: [
        {
          text: `•	Store manager to mandatorily raise call log with transaction details [RRN, Amount, Transaction date, MOP=Jiopay UPI DQR] with central refund team - <a>ARR.Refund@ril.com</a>.
  •	Refund process is similar to existing process. Refund is processed via central refund team ARR.Refund@ril.com.
  •	In case of excess credit, Refund team will process the refund and customer will get the credit after refund initiation in T+2 days.`,
          link: 'mailto:ARR.Refund@ril.com',
        },
      ],
    },
    {
      title: 'Will there be any training provided on the usage of DQR?',
      subTitles: [
        `•	Training on DQR would be a one-time activity and would be communicated to them by their cluster heads or RRL support.
  •	However, any feature addition or update on the product would be communicated to them through DIY videos, or store communications by RRL Support team.`,
      ],
    },
    {
      title: 'In case of transaction timeout how to check if money is credited or not?',
      subTitles: [
        'The store to click on Check Status to understand transaction status. In case, the status is still not confirmed and there is timeout, then merchant should cancel the order and create new order. The customer would have to make the payment again. The earlier payment (if made) would be refunded back to customer.',
      ],
    },
    {
      title: 'How will the settlement happen in case of payment made by customer via DQR?',
      subTitles: ['T+1 day settlement to RRL settlement account.'],
    },
    {
      title: 'When to use “Cancel” option in check status?',
      subTitles: [
        `•	This option should be used when the Cashier initiated the payment, but customer has not started payment from his end. Following scenarios to be considered – 
        o  Customer wish to add more products.
        o  Customer has not started the payment.
        o  Customer wish to change the MOP.
        o  Payment failed at customer side, and he wants to change the MOP.`,
      ],
    },
    {
      title: 'When not to use “Cancel” option? Scenarios where cancel option should not be used',
      subTitles: [
        `•	Payment initiated but it is pending due to network or some other issue. Following scenarios to be considered
        o  Please wait until it’s either failed or success at customer end.
        o  Request customer confirmation on transaction before using cancel option.
        o  Customer side payment is successful and confirmation is not received at RPOS, after 2 mins of timeout.`,
      ],
    },
  ],
  Settlement: [
    {
      title: 'What are settlements?',
      subTitles: [
        'Settlement is the process through which you receive funds in your bank account for the money collected from your customers for a particular product/service. Settlement frequency may vary based on your agreement with JioPay Business. It is generally processed on T+1* working days (T being the date of capture of payment).',
      ],
    },
    {
      title: 'How to check settlements in my bank account?',
      subTitles: [
        'A Unique Transaction Reference (UTR) number is given by the banking partner for each settlement. UTR can be viewed by clicking on the settlement ID in the section or downloading the settlement report. You can use the UTR number to track the settlement in your bank account.',
      ],
    },
    {
      title: "What should I do if I'm not receiving my settlements?",
      subTitles: [
        {
          text: `The settlement cycle is usually T+1* working days (T being the date of capture of payment). In case the settlement has not been credited to your bank account as per your settlement frequency, we recommend you follow the steps mentioned below:  
   
            •  Login to the JioPay Business App or Dashboard and visit the My Profile section. 
            •  Check if the settlement information on your profile is the same as the one you are checking for the receipt of settlement funds from JioPay.
            •  If the settlement information on the page is correct, then check your bank account for any credit transaction from 'JioPay' or 'RPSL' or 'Reliance Payment Solutions'. Please don't worry your money is safe with us. If you don't receive your money within two days, kindly contact JioPay Business Merchant support. If the settlement account is different, please send a request to <a>merchant.support@jiopay.in</a> for updating the settlement account with the attached cancelled cheque as a proof.`,
          link: 'mailto:merchant.support@jiopay.in',
        },
      ],
    },
    {
      title: 'I believe that I have received partial or incorrect settlement in my account?',
      subTitles: [
        {
          text: `If you believe that you have received a partial or incorrect settlement in your account, please follow these steps to investigate the issue:
  •  Login to the JioPay Business App or Dashboard.
  •  Visit the ‘Transactions’ section on the App, or the ‘Report Section’ on the web Dashboard.
  •  Filter the date of payments for which you have received the incorrect settlement.
  •  Add the amount for all transactions which are tagged as ‘Success’.
  •  Check if the same amount post deducting the transaction processing fees and taxes has been deposited in your linked Bank Account.   
  •  If you have not received the same amount, contact us at <a>merchant.support@jiopay.in</a>.`,
          link: 'merchant.support@jiopay.in',
        },
      ],
    },
    {
      title: 'How do I Update settlement bank account number?',
      subTitles: [
        'To update your settlement bank account number, email merchant.support@jiopay.in with your registered mobile number and the details of your new bank account. Attach a cancelled cheque as proof. The support team will assist you further.',
      ],
    },
    {
      title:
        'Do I have to do manual settlement for my account every day to get the funds for payments collected by me?',
      subTitles: [
        'No, as a JioPay Business merchant, you do not need to manually initiate settlement or batch closure for your account. The process of settling funds for the payments collected by you is automated. The unsettled transactions are automatically settled in your bank account based on your settlement cycle, without the need for any manual intervention from your side.',
      ],
    },
    {
      title: 'Why is my settlement on hold for some transactions?',
      subTitles: [
        `We understand that you would be concerned about the hold on your settlement. We would like to assure you that holds on settlements are a standard practice in the payment processing industry and are put in place to ensure the security and integrity of your transactions.\n
  Our compliance and risk teams monitor the transactions for various risks. These holds are usually temporary and typically last for a few business days while we conduct a thorough review of your transactions. Our teams might reach out to you on your registered email-id/mobile number for certain clarifications. Once a satisfactory response has been received we will release the funds to your account as per the agreed frequency.`,
      ],
    },
  ],
  Transaction: [
    {
      title: 'How can I disable SMS notification from dashboard?',
      subTitles: [
        `For disabling SMS Notification you can follow below steps.
  •  Go to settings tab & select user management.
  •  Click on Action and select edit permission for whichever user you want to disable notification.
  •  Uncheck the notification permission check box & click on save changes.
  •  Now notification are disable for this users.`,
        '*Note: only admin or users who have user management permission can change permissions of other sub users.',
      ],
    },
    {
      title: 'How can I add new number for SMS from dashboard?',
      subTitles: [
        `For adding new number for notification you can follow below steps.
  •  Go to settings tab & select user management.
  •  Click on Add new users.
  •  Enter name, mobile number of the user.
  •  Give notification rights in Access rights & click on add user.
  •  Now new mobile number is added for SMS notification.`,
        '*Note: only admin or users who have user management permission can change permissions of other sub users.',
      ],
    },
  ],
  Refunds: [
    {
      title: 'How can I issue refunds to my customers for any payments made by them?',
      subTitles: [
        `To issue refunds using the JioPay Business App or Dashboard, follow these steps:
  •  Login to the app or dashboard.
  •  Locate the transaction for refund.
  •  Select the transaction and choose "Refund".
  •  Enter the refund amount (full or partial).
  •  Confirm the refund request.`,
        'Refunds can be issued up to the value of the original transaction and within 180 days from the transaction date, subject to availability of sufficient settlement amount.',
      ],
    },
    {
      title: 'How to check the status of refund?',
      subTitles: [
        'You can check the status of the refund under refund tab on dashboard. Refund is successful processed if the refund status is Accepted or Success.',
      ],
    },
    {
      title: 'How to check ARN for refund?',
      subTitles: [
        `There are two ways to check this 
  1.  You can check the ARN inside refund history tab on dashboard.
  2.  You can search for the transaction for which refund has been processed. Click on the transaction and you can find refund details at the bottom.`,
      ],
    },
    {
      title: 'What should I do if refund is not credited in my customer’s account?',
      subTitles: [
        `If a refund is not credited to your customer's account, please keep the following in mind:
  
  1.  Refund Deduction: The refund amount will be deducted from any pending settlements in your account. If there are no pending settlements, the refund will be on hold.
          
  2.  Settlement Availability: The refund will be processed when a new payment is received from another customer for an amount equal to or greater than the refund amount.`,
        "For example, if you try to refund Rs. 100 to customer X but have no pending settlements and no new payments, the refund will be on hold. Once a new payment is received, the refund will be processed and credited to the customer's account.",
        {
          text: 'Please ensure that you have pending settlements or new payments to cover the refund amount. For further assistance, contact <a>merchant.support@jiopay.in</a>.',
          link: 'merchant.support@jiopay.in',
        },
      ],
    },
    {
      title: 'Can I cancel a refund?',
      subTitles: [
        {
          text: "Once a refund has been processed successfully, it cannot be cancelled. The refunded amount has already been transferred to the customer's account, and the transaction is considered final. It's important to double-check the refund details before initiating the process to ensure accuracy. If you have any concerns or need further assistance, please contact <a>merchant.support@jiopay.in</a>.",
          link: 'merchant.support@jiopay.in',
        },
      ],
    },
    {
      title: 'Do you charge for refund?',
      subTitles: [
        'We do not charge for refunds. However please note that the processing charges levied by RPSL for the original payment will not be reversed.',
      ],
    },
    {
      title: 'Can we do bulk refund?',
      subTitles: [
        'Yes, you have the option to perform bulk refunds using the JioPay dashboard. You can upload a refund file in the format specified on the dashboard. Once the file is uploaded, the system will process the refunds and provide you with the number of successful and failed refund records.',
      ],
    },
    {
      title: 'What are the steps for Bulk refund?',
      subTitles: [
        `To process bulk refund please follow below steps:
  •	 Go to refund section and click on initiate bulk refund & download the sample file.
  •	 Mention your Merchant ID in the entity column.
  •	 Enter Method type as 211.
  •	 Enter transaction ID under original transaction ID.
  •	 Enter transaction amount under original transaction amount.
  •	 Enter refund amount that has to be processed under amount section.
  •	 Save the file with the given naming convention  jfs_yyyymmddhhmmss_mid_recordscount
        o  jfs is static field.
        o  yyyymmddhhmmss is year, month, day, hours, min & seconds.
        o  mid is your merchant ID.
        o  record count is the refund count.
        o  Please ensure you follow above steps for successful refund processing.`,
      ],
    },
    {
      title: 'Do we have a format for bulk refund report?',
      subTitles: [
        'Yes, there is particular format for Bulk refund report which you can download from merchant Dashboard. You can go to refund section and click on initiate bulk refund & download the sample file. Any deviation from the standard format will lead to failure of bulk refund.',
      ],
    },
    {
      title: 'Is partial refund allowed in bulk refund?',
      subTitles: [
        'Yes, Partial refund is allowed. You can add partial refund amount in the amount section of refund file.',
      ],
    },
    {
      title: 'Can we reprocess failed record in bulk refund?',
      subTitles: [
        'Yes, if any records in the bulk refund file fail to process successfully, you can reprocess those failed records by uploading a new file with the corrected information. Simply create a new file with the failed refund records, ensuring that it follows the required format, and upload it again through the JioPay dashboard. The system will process the new file separately, allowing you to retry the refund for the failed records. Make sure to address any errors or issues that caused the initial failure to increase the chances of successful processing in the reupload.',
      ],
    },
  ],
  BillPayments: [
    {
      title: 'What billers are available for use for JioPay Business App?',
      subTitles: [
        'All billers which are under the Bharat BillPay System are available for use under JioPay Business App',
      ],
    },
    {
      title: 'How to make a Bill Payment for any category? ',
      subTitles: [
        `You need to follow following steps to perform a bill payment on JioPay Business App App.

  1. Click on view all under recharge and pay bills

  2. Tap on Category for which you want to make a bill payment
  
  3. Select your Service provider Name
        
  4. Enter the identification details required
  
  5. Enter the amount
  
  6. Click on pay and enter UPI PIN to complete the payment`,
      ],
    },
    {
      title: 'Can I cancel a bill payment?',
      subTitles: ['No, processed or pending bill payment cannot be cancelled once initiated on JioPay Business App.'],
    },
    {
      title: 'The bill payment transaction failed but the payment was not updated.',
      subTitles: [
        'The amount will be reversed to your account within 3 business days (usually within hours) after payment.',
      ],
    },
    {
      title: 'What is BBPS?',
      subTitles: [
        'Bharat Bill Payment System (BBPS) is an RBI-mandated system that offers integrated and interoperable bill payment services to customers across geographies with an assurance of safe and secure transactions.',
      ],
    },
    {
      title: 'Which type of bills can be paid through BBPS?',
      subTitles: [
        'There are a number of biller categories on the BBPS platform for which you can make payments. These include all types of recurring bills such as electricity, telecom, DTH, Gas, water bills, Insurance, Loan repayments, Education fees, FasTag Recharge, Municipal taxes, Housing society, Subscription fees etc.',
      ],
    },
    {
      title: 'Who is providing the BBPS services through JioPay Business App app? Is it safe?',
      subTitles: [
        'The BBPS services are provided by Jio Payments Bank through JioPay Business App app. JPB is a payment bank licensed from RBI customer unit authorised by NPCI to operate these services. All your payments are secured end to end your money is always safe with regulator approved payment framework.',
      ],
    },
    {
      title: 'On payment summary screen I do see operator/biller reference number. What is this number all about? ',
      subTitles: [
        'Operator/biller reference number is the transaction reference number which your biller has created in its system against your payment. You can use this operator/biller reference number while interacting with your biller for any issue.',
      ],
    },
    {
      title: 'My bill payment status was pending. What does this mean? ',
      subTitles: [
        'Pending status means your transaction is still in process and we are yet to receive the final status. But do not worry, we keep a track of the request and will immediately notify you the status as and when we get the final status. As soon as status is changed, will send you notification (SMS/Email) about the status update.',
      ],
    },
    {
      title: 'My bill payment status shows pending. Can I cancel the transaction? ',
      subTitles: [
        'A pending status means we are yet to receive the final status. Since your bill payment request is already in process, it cannot be cancelled. If we get failure confirmation from your operator, we will immediately process the refund. In case of Jio UPI/CC/DC/Net banking, refund will be reflected in source account within 3-5 working days.',
      ],
    },
    {
      title: 'My bill payment status was pending, and I have already waited for 30 minutes. What should I do? ',
      subTitles: [
        {
          text: 'It is very unlikely that you will not receive update from JioPay Business App app about the pending bill payment for 30 minutes. But nonetheless, please reach out to us at <a>care@jiopay.in</a>',
          link: 'care@jiopay.in',
        },
      ],
    },
    {
      title:
        'I made a bill payment via JioPay Business App app but have not a got the confirmation from my operator but when I pay from their website, I get an instant confirmation. Why is it so? ',
      subTitles: [
        'Few operators take upto 3 days to update the payment status at their end and provide confirmation once they update payment status at their end. The payment mechanism on biller website has different integration than what is being offered to third party service providers like Jio Payments Bank. Hence, you may find different ETAs for payment posting.',
      ],
    },
    {
      title: 'Can I make partial payment of my bill? ',
      subTitles: [
        'Please note, not all billers allow partial payment. If a biller allows the partial payment of the bill, then you can certainly make the partial payment. For editing the amount, please click on the amount field and enter the amount of your choice and make the payment.',
      ],
    },
    {
      title: 'What if I pay on my last day, will my payment still be updated for my account? ',
      subTitles: [
        "If you pay your bill on last day, payment will still be updated at biller's end. The payment update might take upto 2-3 working days. Most of the billers take the payment date as the posting date at their end and not consider this as late payment. But there are few billers which take posting date when the amount is reflected in their account and this might be considered as late payment. Hence, it is advisable to pay your bills at least 3 working days before due date to avoid late payment/service disruption concern.",
      ],
    },
    {
      title:
        'I have made multiple payments due to some issue. Will JioPay Business App app make refund for multiple payments?',
      subTitles: [
        'As soon as payment is made on JioPay Business App app, payment request is sent to the biller. Few billers like telecoms adjust these payment against the future bill while others might opt for refunding the multiple payments. JioPay Business App app will process the refund to the source account as soon as it receives the refund instructions from biller.',
      ],
    },
    {
      title: 'How will I get to know if the bill was paid?',
      subTitles: [
        'Customer will receive transaction successful message from JioPay Business App app. Though biller update the payment status at their end within 2-3 working days. Please check with your billers call center/website/sms about bill payment status. You may want to quote operator/biller reference number shown on payment summary screen while interacting with your biller.',
      ],
    },
    {
      title: 'What are the different categories for which I can make a bill payment?',
      subTitles: [
        `Following are the list of categories for which you can make bill payment using JioPay Business App App.

  1.  Broadband Postpaid
  2.  Cable TV
  3.  Clubs and Associations
  4.  Credit Card
  5.  DTH
  6.  Donations
  7.  Education Fees
  8.  Electricity
  9.  Fastag
  10. Gas
  11. Health Insurance
  12. Hospital
  13. Hospital and Pathology
  14. Housing Society
  15. Insurance
  16. Landline Postpaid
  17. Loan Repayment
  18. LPG Gas
  19. Mobile Postpaid
  20. Municipal Services
  21. Recurring Deposit
  22. Rental
  23. Subscription  
  24. Water
        `,
      ],
    },
    {
      title: 'My FASTag balance is not updated even after doing a successful recharge',
      subTitles: [
        `If your FASTag balance is not activated after your recharge is marked successful on JioPay Business App, there might be a delay in updating the status of the recharge from the FASTag issuing bank, please wait for 2 working days for the same. 

In case it still does not work, you can contact your FASTag issuing bank`,
      ],
    },
    {
      title: 'My FASTag recharge is pending, what do I do?',
      subTitles: [
        `In rare cases FASTag recharges take 30 mins to process, you can check the latest status in the passbook section of the app.
If your recharge fails, the entire amount will be refunded to you in 4-7 working days.`,
      ],
    },
    {
      title: 'How do I know the issuer bank of my FASTag?',
      subTitles: [
        'The name of issuer that issued FASTag is displayed on the left side corner of the blue strip of the FASTag.',
      ],
    },
    {
      title: 'Can I buy FASTag on JioPay Business App App?',
      subTitles: [
        `You cannot buy a FASTAg on JioPay Business App app but you can recharge an already issued and active FASTag bought from any other supported issuer bank. Currently many issuers are supported but this list keeps on expanding as we add more issuers. Some of those are as follows:

• Axis Bank FASTag
• Bank of Baroda - Fastag
• HDFC Bank - Fastag
• IDFC FIRST Bank - FasTag
• Indian Highways Management Company Ltd FASTag
• IndusInd Bank FASTag
• ICICI Bank Fastag 
        `,
      ],
    },
    {
      title: 'Can I cancel a FASTag recharge I have made? ',
      subTitles: [
        'No, you cannot cancel a FASTag recharge once you have submitted the request, and your account is debited.',
      ],
    },
    {
      title: 'I have not received the desired plan',
      subTitles: [
        'We highly recommend you cross check the plans available on service provider website before attempting any recharge.',
      ],
    },
    {
      title: 'How much Agent Fee (Convinience fee) can I charge to customer for bill payment',
      subTitles: [
        `The Agent Fee which can be charged to the customer will be displayed on the App screen after successful bill fetch.
        
Below is the summary of the Agent fee you can charge:
        
  • For Amount Between Rs 1 to Rs 500 -> Rs 5
  • For Amount Between Rs 501 to Rs 1000 -> Rs 10
  • For Amount Between Rs 1001 to Rs 5000 -> Rs 15
  • For Amount Between Rs 5001 to Rs 10000 -> Rs 20
  • For Amount Between Rs 10001 to Rs 99999 -> Rs 25
        
In case the convenience fee is shown as 0, the merchant can charge upto 25/- and/or follow the same logic mentioned above
        `,
      ],
    },
    {
      title: 'The bill payment transaction failed. How do I refund money to customer.',
      subTitles: [
        'In case the bill payment transaction is failed then the refund will be received in the Agent Source Account (the VPA entered by Agent during the transaction). Agent need to call the customer and refund money to them for such cases.',
      ],
    },
    {
      title:
        'My Customer does not have Whatsapp or any other medium to share the transaction receipt. How do I share the receipt with them',
      subTitles: [
        'It is preferable to share the receipt generated in JioPay Business App to customer via any digital communication (whatsapp/email etc). However in case these medium is not available with customer then Agent need to share the receipt with customer as a print mode.',
      ],
    },
  ],
}
